// ----------------------------------------------------------------------

export function localStorageAvailable() {
  try {
    const key = "__some_random_key_you_are_not_going_to_use__";
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
}

export function localStorageGetItem(key, defaultValue = "") {
  const storageAvailable = localStorageAvailable();

  let value;

  if (storageAvailable) {
    value = localStorage.getItem(key) || defaultValue;
  }

  return value;
}

export function getStorageItem(key, defaultValue) {
  try {
    const storedValue = window.localStorage.getItem(key);

    return storedValue === null ? defaultValue : JSON.parse(storedValue);
  } catch (error) {
    // Storage blocked by the browser, or a stored value we can no longer parse.
    return defaultValue;
  }
}
export function setStorageItem(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // Nothing to do: the preference simply will not survive this session.
  }
}
